import './App.css';
import {Box} from '@mui/material';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import TopBar from "./components/TopBar";
import React from "react";
import IfAuthenticated from "./utils/authenticated";
import Recipe from "./views/Recipe";
import Guide from "./views/Guide";
import Landing from "./views/Landing";
import PhotoRecommender from "./views/PhotoRecommender";
import Steps from "./views/Steps";
import DoughCalculator from "./views/DoughCalculator";

function App() {
    return (
        <Box sx={{width: "100%", padding: 0, margin: 0}}>
            <Router>
                <TopBar/>
                <IfAuthenticated>
                    <Box component="main">
                        <Routes>
                            <Route path="/" element={<Landing/>}/>
                            <Route path="/dough" element={<DoughCalculator/>}/>
                            <Route path="/recipe" element={<Recipe/>}/>
                            <Route path="/steps" element={<Steps/>}/>
                            <Route path="/guide/:recipe" element={<Guide
                                photoUrl={"https://publiclegurudepizza.blob.core.windows.net/public/pizza-example-neapolitan-1.jpg"}
                                heading={"Neapolitanische Pizza"}
                                ingredients={["Mehl", "Wasser", "Salz", "Hefe"]}
                                methodSteps={["Mehl und Wasser vermischen", "Salz und Hefe hinzufügen", "Teig kneten"]}
                            />}/>
                            <Route path="/recommend" element={<PhotoRecommender/>}/>
                        </Routes>
                    </Box>
                </IfAuthenticated>
            </Router>
        </Box>
    );
}

export default App;
